export const PLAID_ERROR_CODE = {
  ITEM_LOGIN_REQUIRED: 'ITEM_LOGIN_REQUIRED',
};

export const PLAID_INVESTMENT_DATA_TYPE = {
  HOLDINGS: 'HOLDINGS',
  TRANSACTIONS: 'TRANSACTIONS',
};
